(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            $(document).ready(function() {
            
              var prod_carousel_items_js_1_autoplay = false;
              if ( $('.prod_carousel_items_js_product-recommendations__1').attr('data-autoplay') == 'true' ) {
                prod_carousel_items_js_1_autoplay = $('.prod_carousel_items_js_product-recommendations__1').attr('data-autoplaySpeed');
              }

              var cellAlign = 'left'
              var draggable = '>1';
              if ( $(window).width() > 768 && $('.prod_carousel_items_js_product-recommendations__1 .prod_carousel_item').length < 4 ) {
                cellAlign = 'center';
                var draggable = false; 
              }

              var pageDots = false;
              if ( $('.prod_carousel_items_js_product-recommendations__1').attr('data-pageDots') == 'true' ) {
                pageDots = true;
              }
              var prevNextButtons = false;
              if ( $('.prod_carousel_items_js_product-recommendations__1').attr('data-prevNextButtons') == 'true' ) {
                prevNextButtons = true;
              }
              
              $('.prod_carousel_items_js_product-recommendations__1').flickity({
                // options
                cellAlign: cellAlign,
                draggable: draggable, 
                contain: true,
                wrapAround: true,
                autoPlay: prod_carousel_items_js_1_autoplay,
                pauseAutoPlayOnHover: true,
                arrowShape: '',
                pageDots: pageDots,
                prevNextButtons: prevNextButtons
              }); 
              flickity_arrow_center ();
              $('.prod_carousel_items_js_product-recommendations__1.prod_carousel_items').attr('data-qty', $('.prod_carousel_items_js_product-recommendations__1 .prod_carousel_item').length );
              
            
            });

          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);



  } catch(e) { console.error(e); }
})();
})();
